export enum SourceApp {
  TecEx = 'TecEx',
  Zee = 'Zee',
}
